var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './LoadingSpinner.scss';
import classNames from 'classnames';
import { usePrevious } from '@hooks';
import React, { useEffect, useRef, useState } from 'react';
import { Spin } from 'antd';
export const LoadingSpinner = (_a) => {
    var { children, spinning = false, minDuration = 0, opaque, size = 'large' } = _a, rest = __rest(_a, ["children", "spinning", "minDuration", "opaque", "size"]);
    const timeoutId = useRef();
    const [minLoading, setMinLoading] = useState(false);
    const previousSpinning = usePrevious(spinning);
    useEffect(() => {
        if (spinning && !previousSpinning) {
            setMinLoading(true);
            if (timeoutId.current) {
                clearTimeout(timeoutId.current);
            }
            timeoutId.current = setTimeout(() => {
                setMinLoading(false);
            }, minDuration);
        }
    }, [spinning, minDuration, previousSpinning]);
    return (React.createElement("div", { className: classNames('loading-spinner', {
            'empty-spinner': !children,
            opaque
        }) },
        React.createElement(Spin, Object.assign({ size: size, spinning: spinning || minLoading }, rest), children)));
};
